import React from 'react'

const Receive = () => {
  return (
    <div>Receive</div>
  )
}

export default Receive